export default __webpack_public_path__ + "static/media/arrow-left-blue.6c7990c5.svg";